export default __webpack_public_path__ + "static/media/about-us.cff4e4a5.jpg";